import {Inject, Injectable} from '@angular/core';
import {AsyncSubject, Observable} from 'rxjs';
import {CognitoAuth} from 'amazon-cognito-auth-js';
import {ConfigurationService} from './configuration.service';
import {UrlUtils} from '../utils/url.utils';

@Injectable()
export class AuthenticationService {
  private cognitoAuth: CognitoAuth;
  private readonly saveUrlKey = 'r2d2-user-input-url';
  private readonly authenticated$ = new AsyncSubject<string>();
  defaultRegion: any;
  defaultArc: any;

  constructor(
    @Inject('UrlUtils') private readonly urlUtils: UrlUtils,
    @Inject('ConfigurationService') private readonly configurationService: ConfigurationService
  ) {
    configurationService.getSettings().subscribe(settings => {
      this.defaultRegion = settings.defaultRegion;
      this.defaultArc = settings.defaultArc;

      // Dynamically set redirect URIs based on current domain
      // so both old and new domains work with the same config
      const currentOrigin = window.location.origin;
      const cognitoConfig = {
        ...settings.cognitoAuth,
        RedirectUriSignIn: currentOrigin,
        RedirectUriSignOut: currentOrigin,
      };

      this.cognitoAuth = new CognitoAuth(cognitoConfig);
      this.setupCognitoAuth();
      this.authenticate();

    });
  }

  getAuthenticated(): Observable<string> {
    return this.authenticated$;
  }

  private setupCognitoAuth() {
    this.cognitoAuth.useCodeGrantFlow();
    this.cognitoAuth.userhandler = {
      onFailure: (err: any) => {
        console.log('Cognito auth failure', err);
        // redirect to sign in page
        this.cognitoAuth.signOut();
      },
      onSuccess: (_) => {
        console.log('Cognito auth success');
        this.publishAuthenticated();
        this.restoreUrl();
      }
    };
  }

  private authenticate() {
    if (this.cognitoAuth.getSignInUserSession().isValid()) {
      console.log('Valid session');
      this.publishAuthenticated();
    } else if (this.urlUtils.getSearchParam(location.href, 'code') !== undefined) {
      this.cognitoAuth.parseCognitoWebResponse(location.href);
    } else {
      console.log('Getting session');
      this.saveUrl();
      this.cognitoAuth.getSession();
    }
  }

  private saveUrl() {
    sessionStorage.setItem(this.saveUrlKey, location.href);
  }

  private restoreUrl() {
    const newHref = sessionStorage.getItem(this.saveUrlKey);
    history.replaceState(undefined, undefined, newHref);
    sessionStorage.removeItem(this.saveUrlKey);
  }

  private publishAuthenticated() {
    this.authenticated$.next(this.cognitoAuth.getSignInUserSession().getIdToken().getJwtToken().toString());
    this.authenticated$.complete();
  }

  private getDecodedJWTToken() {
    let jwt = this.cognitoAuth.getSignInUserSession().getIdToken().getJwtToken().toString();
    let decodedValue = JSON.parse(window.atob(jwt.split('.')[1]));
    return decodedValue;
  }

  getUserDetails() {
    let decodedValue = this.getDecodedJWTToken();
    let userDetails = {
      'alias': decodedValue['email'].split('@')[0],
      'email': decodedValue['email'],
      'cognito:username': decodedValue['cognito:username']
    };
    return userDetails;
  }

}
